export default __webpack_public_path__ + "static/Overpass-Black-Italic-388423a0fedb2fb453d09484207b156e.woff2";